(function () {
  'use strict';

  var CustomFlow = {
    state: {
      step: 'upload',
      files: [],
      fileSelected: false,
      activeCategory: null,
      selectedOptions: {},
      currentVariant: null,
    },

    productsData: {},
    els: {},

    init: function () {
      this.cacheElements();

      // Parse multi-product data
      var dataEl = document.getElementById('cf-products-json');
      if (dataEl) {
        try {
          this.productsData = JSON.parse(dataEl.textContent);
        } catch (e) {
          console.error('[CustomFlow] Failed to parse products data', e);
        }
      }

      // Determine default category from first active category button
      var activeBtn = document.querySelector('.cf-category-btn.is-active');
      if (activeBtn) {
        this.state.activeCategory = activeBtn.dataset.category;
      }

      this.bindEvents();
      this.initDefaultsForCategory(this.state.activeCategory);
      this.initShowcase();

      // Set initial idea placeholder & visibility for default category
      if (this.state.activeCategory) {
        var catData = this.productsData[this.state.activeCategory];
        var ideaSection = document.getElementById('cfIdeaSection');
        if (ideaSection) {
          ideaSection.style.display = (catData && catData.showIdeaInput) ? '' : 'none';
        }
        if (this.els.ideaText) {
          this.els.ideaText.placeholder = (catData && catData.ideaPlaceholder) || '';
        }
      }
    },

    cacheElements: function () {
      this.els = {
        form: document.getElementById('CustomFlowForm'),
        variantInput: document.getElementById('cf-variant-id'),
        categoryInput: document.getElementById('cf-category-input'),
        fileInput: document.getElementById('cfFileInput'),
        uploadZone: document.getElementById('cfUploadZone'),
        uploadIdle: document.getElementById('cfUploadIdle'),
        uploadPreview: document.getElementById('cfUploadPreview'),
        previewList: document.getElementById('cfPreviewList'),
        addMoreBtn: document.getElementById('cfAddMore'),
        fileFields: document.getElementById('cfFileFields'),
        uploadError: document.getElementById('cfUploadError'),
        nextBtn: document.getElementById('cfNextToCustomize'),
        backBtn: document.getElementById('cfBackToUpload'),
        summaryImg: document.getElementById('cfSummaryImg'),
        summaryName: document.getElementById('cfSummaryName'),
        editUploadBtn: document.getElementById('cfEditUpload'),
        stepIndicators: document.querySelectorAll('[data-step-indicator]'),
        categoryBtns: document.querySelectorAll('.cf-category-btn'),
        optionPanels: document.querySelectorAll('.cf-options-panel'),
        footer: document.getElementById('cfFooter'),
        priceValue: document.getElementById('cfPrice'),
        comparePrice: document.getElementById('cfComparePrice'),
        addToCartBtn: document.getElementById('cfAddToCart'),
        panelUpload: document.querySelector('[data-step="upload"]'),
        panelCustomize: document.querySelector('[data-step="customize"]'),
        ideaText: document.getElementById('cfIdeaText'),
      };
    },

    bindEvents: function () {
      var self = this;

      // Header cart button
      var headerCartBtn = document.getElementById('cfHeaderCartBtn');
      if (headerCartBtn) {
        headerCartBtn.addEventListener('click', function () {
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.openMenuDrawer === 'function') {
            drawer.openMenuDrawer();
          } else {
            window.location.href = '/cart';
          }
        });
      }
      this.updateHeaderCartCount();

      // Category toggle
      this.els.categoryBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.handleCategory(btn);
        });
      });

      // Drag and drop
      var zone = this.els.uploadZone;
      if (zone) {
        zone.addEventListener('dragover', function (e) {
          e.preventDefault();
          e.stopPropagation();
          zone.classList.add('is-dragover');
        });
        zone.addEventListener('dragleave', function (e) {
          e.preventDefault();
          e.stopPropagation();
          zone.classList.remove('is-dragover');
        });
        zone.addEventListener('drop', function (e) {
          e.preventDefault();
          e.stopPropagation();
          zone.classList.remove('is-dragover');
          if (e.dataTransfer.files.length > 0) {
            self.addFiles(e.dataTransfer.files);
          }
        });

        // Click anywhere on idle zone to open file picker
        if (this.els.uploadIdle) {
          this.els.uploadIdle.addEventListener('click', function (e) {
            if (!e.target.closest('.cf-upload-zone__browse')) {
              self.els.fileInput.click();
            }
          });
        }
      }

      // File input change
      if (this.els.fileInput) {
        this.els.fileInput.addEventListener('change', function (e) {
          if (e.target.files.length > 0) {
            self.addFiles(e.target.files);
            e.target.value = '';
          }
        });
      }

      // Add more photos button
      if (this.els.addMoreBtn) {
        this.els.addMoreBtn.addEventListener('click', function () {
          self.els.fileInput.click();
        });
      }

      // Remove buttons in preview list
      if (this.els.previewList) {
        this.els.previewList.addEventListener('click', function (e) {
          var removeBtn = e.target.closest('[data-remove-index]');
          if (removeBtn) {
            self.removeFile(parseInt(removeBtn.dataset.removeIndex, 10));
          }
        });
      }

      // Next button (upload -> customize)
      if (this.els.nextBtn) {
        this.els.nextBtn.addEventListener('click', function () {
          self.goToStep('customize');
        });
      }

      // Back button (customize -> upload)
      if (this.els.backBtn) {
        this.els.backBtn.addEventListener('click', function () {
          self.goToStep('upload');
        });
      }

      // Edit upload link in summary
      if (this.els.editUploadBtn) {
        this.els.editUploadBtn.addEventListener('click', function () {
          self.goToStep('upload');
        });
      }

      // Event delegation for all option clicks (pills, swatches, art styles)
      if (this.els.form) {
        this.els.form.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-option-position][data-option-value]');
          if (!btn) return;

          var groupSelector;
          if (btn.classList.contains('cf-swatch')) {
            groupSelector = '.cf-swatch';
          } else if (btn.classList.contains('cf-art-style')) {
            groupSelector = '.cf-art-style';
          } else if (btn.classList.contains('cf-pill')) {
            groupSelector = '.cf-pill';
          } else {
            return;
          }

          self.handleOptionSelect(btn, groupSelector);
        });
      }

      // Idea textarea input
      if (this.els.ideaText) {
        this.els.ideaText.addEventListener('input', function () {
          self.updateContinueButton();
        });
      }

      // Form submit
      if (this.els.form) {
        this.els.form.addEventListener('submit', function (e) {
          self.handleSubmit(e);
        });
      }
    },

    updateContinueButton: function () {
      var hasFile = this.state.fileSelected;
      var ideaSection = document.getElementById('cfIdeaSection');
      var ideaVisible = ideaSection && ideaSection.style.display !== 'none';
      var hasIdea = ideaVisible && this.els.ideaText && this.els.ideaText.value.trim().length > 0;
      if (this.els.nextBtn) this.els.nextBtn.disabled = !(hasFile || hasIdea);
    },

    initDefaultsForCategory: function (category) {
      if (!category) return;

      // If already initialized, just find variant
      if (this.state.selectedOptions[category]) {
        this.findAndUpdateVariant();
        return;
      }

      this.state.selectedOptions[category] = {};
      var panel = document.querySelector(
        '.cf-options-panel[data-category="' + category + '"]'
      );
      if (!panel) return;

      var self = this;
      panel
        .querySelectorAll('[data-option-position][data-option-value].is-active')
        .forEach(function (btn) {
          self.state.selectedOptions[category][btn.dataset.optionPosition] =
            btn.dataset.optionValue;
        });

      this.findAndUpdateVariant();
    },

    /* ---- Category ---- */
    handleCategory: function (btn) {
      this.els.categoryBtns.forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-checked', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-checked', 'true');

      var category = btn.dataset.category;
      this.state.activeCategory = category;

      if (this.els.categoryInput) {
        this.els.categoryInput.value = category;
      }

      // Toggle option panels
      this.els.optionPanels.forEach(function (panel) {
        panel.style.display = 'none';
      });
      var activePanel = document.querySelector(
        '.cf-options-panel[data-category="' + category + '"]'
      );
      if (activePanel) {
        activePanel.style.display = '';
      }

      // Switch showcase gallery
      this.switchShowcase(category);

      // Switch hero heading
      var headings = document.querySelectorAll('[data-heading-category]');
      headings.forEach(function (h) { h.classList.remove('is-active'); });
      var activeHeading = document.querySelector('[data-heading-category="' + category + '"]');
      if (activeHeading) activeHeading.classList.add('is-active');

      // Switch social proof tagline
      var taglines = document.querySelectorAll('[data-tagline-category]');
      taglines.forEach(function (t) { t.classList.remove('is-active'); });
      var activeTagline = document.querySelector('[data-tagline-category="' + category + '"]');
      if (activeTagline) activeTagline.classList.add('is-active');


      // Switch idea visibility & placeholder per category
      var catData = this.productsData[category];
      var ideaSection = document.getElementById('cfIdeaSection');
      if (ideaSection) {
        ideaSection.style.display = (catData && catData.showIdeaInput) ? '' : 'none';
      }
      if (this.els.ideaText) {
        this.els.ideaText.placeholder = (catData && catData.ideaPlaceholder) || '';
      }

      // Initialize defaults for this category if not done yet
      this.initDefaultsForCategory(category);
    },

    /* ---- Showcase Gallery ---- */
    initShowcase: function () {
      var showcase = document.getElementById('cfShowcase');
      if (!showcase) return;

      var root = document.getElementById('CustomFlow');
      var speed = root ? parseInt(root.dataset.gallerySpeed, 10) * 1000 : 4000;
      if (!speed || speed < 1000) speed = 4000;

      // Stagger each slot so they don't all change at once
      var self = this;
      this._showcaseIntervals = [];
      var slots = showcase.querySelectorAll('.cf-showcase__slot');
      slots.forEach(function (slot, i) {
        var delay = i % 3 * Math.floor(speed / 3);
        var timer = setTimeout(function () {
          self._showcaseIntervals.push(setInterval(function () {
            self.rotateOneSlot(slot);
          }, speed));
        }, delay);
        self._showcaseIntervals.push(timer);
      });
    },

    rotateOneSlot: function (slot) {
      // Only rotate if this slot's parent group is active
      var group = slot.closest('.cf-showcase__group');
      if (!group || !group.classList.contains('is-active')) return;

      var imgs = slot.querySelectorAll('.cf-showcase__img');
      if (imgs.length < 2) return;

      var current = slot.querySelector('.cf-showcase__img.is-active');
      if (!current) return;

      var candidates = [];
      for (var i = 0; i < imgs.length; i++) {
        if (imgs[i] !== current) candidates.push(imgs[i]);
      }
      var next = candidates[Math.floor(Math.random() * candidates.length)];

      current.classList.remove('is-active');
      next.classList.add('is-active');
    },

    switchShowcase: function (category) {
      var groups = document.querySelectorAll('[data-showcase-category]');
      groups.forEach(function (g) {
        g.classList.remove('is-active');
      });
      var active = document.querySelector('[data-showcase-category="' + category + '"]');
      if (active) active.classList.add('is-active');
    },

    /* ---- File Upload ---- */
    MAX_FILES: 5,

    addFiles: function (fileList) {
      var validTypes = ['image/jpeg', 'image/png'];
      this.hideUploadError();

      for (var i = 0; i < fileList.length; i++) {
        var file = fileList[i];
        if (this.state.files.length >= this.MAX_FILES) {
          this.showUploadError('You can upload up to ' + this.MAX_FILES + ' photos.');
          break;
        }
        if (validTypes.indexOf(file.type) === -1) {
          this.showUploadError('Please upload JPG or PNG files.');
          continue;
        }
        if (file.size > 10 * 1024 * 1024) {
          this.showUploadError('Each file must be under 10 MB.');
          continue;
        }
        this.state.files.push(file);
      }

      this.state.fileSelected = this.state.files.length > 0;
      this.syncFileInputs();
      this.renderPreviews();
      this.updateContinueButton();
    },

    removeFile: function (index) {
      this.state.files.splice(index, 1);
      this.state.fileSelected = this.state.files.length > 0;
      this.syncFileInputs();
      this.renderPreviews();
      this.updateContinueButton();
      this.hideUploadError();
    },

    photoPropName: function (index) {
      return index === 0 ? 'properties[Photo]' : 'properties[Photo ' + (index + 1) + ']';
    },

    // Mirror state.files into hidden file inputs so the native form
    // fallback submits every photo as its own line-item property
    syncFileInputs: function () {
      var container = this.els.fileFields;
      if (!container) return;
      container.innerHTML = '';
      var self = this;
      this.state.files.forEach(function (file, i) {
        try {
          var dt = new DataTransfer();
          dt.items.add(file);
          var input = document.createElement('input');
          input.type = 'file';
          input.name = self.photoPropName(i);
          input.tabIndex = -1;
          input.files = dt.files;
          container.appendChild(input);
        } catch (e) {
          // Older browsers: AJAX path still submits from state.files
        }
      });
    },

    renderPreviews: function () {
      var list = this.els.previewList;
      if (!list) return;

      list.querySelectorAll('img[data-object-url]').forEach(function (img) {
        URL.revokeObjectURL(img.src);
      });
      list.innerHTML = '';

      this.state.files.forEach(function (file, i) {
        var item = document.createElement('div');
        item.className = 'cf-preview-item';
        item.innerHTML =
          '<span class="cf-preview-item__thumb"><img alt="" data-object-url></span>' +
          '<span class="cf-preview-item__name"></span>' +
          '<button type="button" class="cf-preview-item__remove" data-remove-index="' + i + '" aria-label="Remove photo">&times;</button>';
        item.querySelector('img').src = URL.createObjectURL(file);
        item.querySelector('.cf-preview-item__name').textContent = file.name;
        list.appendChild(item);
      });

      var hasFiles = this.state.files.length > 0;
      if (this.els.uploadIdle) this.els.uploadIdle.style.display = hasFiles ? 'none' : '';
      if (this.els.uploadPreview) {
        if (hasFiles) {
          this.els.uploadPreview.removeAttribute('hidden');
          this.els.uploadPreview.style.display = 'flex';
        } else {
          this.els.uploadPreview.setAttribute('hidden', '');
          this.els.uploadPreview.style.display = 'none';
        }
      }
      this.els.uploadZone.classList.toggle('has-file', hasFiles);
      if (this.els.addMoreBtn) {
        this.els.addMoreBtn.style.display = this.state.files.length >= this.MAX_FILES ? 'none' : '';
      }

      this.updateSummary();
    },

    updateSummary: function () {
      var files = this.state.files;
      if (this.els.summaryImg) {
        if (this._summaryUrl) URL.revokeObjectURL(this._summaryUrl);
        if (files.length > 0) {
          this._summaryUrl = URL.createObjectURL(files[0]);
          this.els.summaryImg.src = this._summaryUrl;
          this.els.summaryImg.style.display = '';
        } else {
          this._summaryUrl = null;
          this.els.summaryImg.src = '';
        }
      }
      if (this.els.summaryName && files.length > 0) {
        this.els.summaryName.textContent = files.length === 1
          ? files[0].name
          : files[0].name + ' + ' + (files.length - 1) + ' more';
      }
    },

    resetUpload: function () {
      this.state.files = [];
      this.state.fileSelected = false;
      if (this.els.fileInput) this.els.fileInput.value = '';
      this.syncFileInputs();
      this.renderPreviews();
      this.updateContinueButton();
      this.hideUploadError();
    },

    showUploadError: function (msg) {
      if (this.els.uploadError) {
        this.els.uploadError.textContent = msg;
        this.els.uploadError.classList.add('is-visible');
      }
    },

    hideUploadError: function () {
      if (this.els.uploadError) {
        this.els.uploadError.classList.remove('is-visible');
      }
    },

    /* ---- Step Navigation ---- */
    goToStep: function (step) {
      this.state.step = step;

      // Toggle panels
      if (step === 'upload') {
        if (this.els.panelUpload) {
          this.els.panelUpload.style.display = 'block';
          this.els.panelUpload.removeAttribute('hidden');
        }
        if (this.els.panelCustomize) {
          this.els.panelCustomize.style.display = 'none';
        }
      } else if (step === 'customize') {
        if (this.els.panelUpload) {
          this.els.panelUpload.style.display = 'none';
        }
        if (this.els.panelCustomize) {
          this.els.panelCustomize.style.display = 'block';
          this.els.panelCustomize.removeAttribute('hidden');
        }

        // Update summary for idea-only submissions
        if (this.els.summaryName && !this.state.fileSelected && this.els.ideaText && this.els.ideaText.value.trim()) {
          this.els.summaryName.textContent = 'Idea: ' + this.els.ideaText.value.trim().substring(0, 50) + '...';
          if (this.els.summaryImg) this.els.summaryImg.style.display = 'none';
        }
      }

      // Update step indicators
      var steps = ['upload', 'customize', 'order'];
      var currentIndex = steps.indexOf(step);

      this.els.stepIndicators.forEach(function (indicator) {
        var indicatorStep = indicator.dataset.stepIndicator;
        var indicatorIndex = steps.indexOf(indicatorStep);

        indicator.classList.remove('is-active', 'is-completed');

        if (indicatorIndex < currentIndex) {
          indicator.classList.add('is-completed');
        } else if (indicatorIndex === currentIndex) {
          indicator.classList.add('is-active');
        }
      });

      // Show/hide footer
      if (this.els.footer) {
        if (step === 'customize') {
          this.els.footer.classList.add('is-visible');
        } else {
          this.els.footer.classList.remove('is-visible');
        }
      }

      // Show/hide social proof and showcase on upload step only
      var socialProof = document.getElementById('cfSocialProof');
      var showcase = document.getElementById('cfShowcase');
      if (socialProof) socialProof.style.display = step === 'upload' ? '' : 'none';
      if (showcase) showcase.style.display = step === 'upload' ? '' : 'none';

      this.updateCartButton();

      // Scroll to top
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },

    /* ---- Option Select ---- */
    handleOptionSelect: function (btn, groupSelector) {
      var group = btn.closest('.cf-option-group');
      if (group) {
        group.querySelectorAll(groupSelector).forEach(function (b) {
          b.classList.remove('is-active');
        });
      }
      btn.classList.add('is-active');

      var category = this.state.activeCategory;
      if (!this.state.selectedOptions[category]) {
        this.state.selectedOptions[category] = {};
      }
      this.state.selectedOptions[category][btn.dataset.optionPosition] =
        btn.dataset.optionValue;

      this.findAndUpdateVariant();
    },

    /* ---- Variant Mapping ---- */
    findAndUpdateVariant: function () {
      var category = this.state.activeCategory;
      var productData = this.productsData[category];
      if (!productData || !productData.variants) return;

      var selectedOptions = this.state.selectedOptions[category] || {};
      var variant = null;

      for (var i = 0; i < productData.variants.length; i++) {
        var v = productData.variants[i];
        var match = true;

        for (var pos in selectedOptions) {
          if (selectedOptions.hasOwnProperty(pos)) {
            var optionIndex = parseInt(pos, 10) - 1;
            if (v.options[optionIndex] !== selectedOptions[pos]) {
              match = false;
              break;
            }
          }
        }

        if (match) {
          variant = v;
          break;
        }
      }

      this.state.currentVariant = variant;

      if (variant) {
        this.els.variantInput.value = variant.id;
        this.updatePrice(variant);
      }

      this.updateOptionAvailability();
      this.updateCartButton();
    },

    /* ---- Option Availability ---- */
    updateOptionAvailability: function () {
      var category = this.state.activeCategory;
      var productData = this.productsData[category];
      if (!productData || !productData.variants) return;

      var selectedOptions = this.state.selectedOptions[category] || {};
      var panel = document.querySelector(
        '.cf-options-panel[data-category="' + category + '"]'
      );
      if (!panel) return;

      var variants = productData.variants;
      var buttons = panel.querySelectorAll(
        '[data-option-position][data-option-value]'
      );

      buttons.forEach(function (btn) {
        var pos = btn.dataset.optionPosition;
        var val = btn.dataset.optionValue;
        var optionIndex = parseInt(pos, 10) - 1;
        var hasAvailable = false;

        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];

          // Must match this button's value
          if (v.options[optionIndex] !== val) continue;

          // Must match all other currently selected options
          var otherMatch = true;
          for (var otherPos in selectedOptions) {
            if (otherPos === pos) continue;
            if (selectedOptions.hasOwnProperty(otherPos)) {
              var otherIndex = parseInt(otherPos, 10) - 1;
              if (v.options[otherIndex] !== selectedOptions[otherPos]) {
                otherMatch = false;
                break;
              }
            }
          }

          if (otherMatch && v.available) {
            hasAvailable = true;
            break;
          }
        }

        if (hasAvailable) {
          btn.classList.remove('is-unavailable');
        } else {
          btn.classList.add('is-unavailable');
        }
      });
    },

    /* ---- Price ---- */
    updatePrice: function (variant) {
      if (!variant || !this.els.priceValue) return;

      this.els.priceValue.textContent = this.formatMoney(variant.price);

      if (this.els.comparePrice) {
        if (
          variant.compare_at_price &&
          variant.compare_at_price > variant.price
        ) {
          this.els.comparePrice.textContent = this.formatMoney(
            variant.compare_at_price
          );
          this.els.comparePrice.style.display = '';
        } else {
          this.els.comparePrice.style.display = 'none';
        }
      }
    },

    formatMoney: function (cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents);
      }

      var amount = (cents / 100).toFixed(2);
      var parts = amount.split('.');
      var intPart = parts[0];
      var decPart = parts[1];

      var lastThree = intPart.slice(-3);
      var rest = intPart.slice(0, -3);
      if (rest.length > 0) {
        lastThree = ',' + lastThree;
        rest = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',');
      }

      var formatted = rest + lastThree;
      if (decPart === '00') {
        return '\u20B9' + formatted;
      }
      return '\u20B9' + formatted + '.' + decPart;
    },

    /* ---- Cart Button State ---- */
    updateCartButton: function () {
      if (!this.els.addToCartBtn) return;

      var variant = this.state.currentVariant;
      var hasInput = this.state.fileSelected || (this.els.ideaText && this.els.ideaText.value.trim().length > 0);
      var canAdd = hasInput && variant && variant.available && this.state.step === 'customize';

      this.els.addToCartBtn.disabled = !canAdd;

      if (!variant) {
        this.els.addToCartBtn.textContent = 'Unavailable';
      } else if (!variant.available) {
        this.els.addToCartBtn.textContent = 'Sold Out';
      } else {
        this.els.addToCartBtn.textContent = 'Add to Cart';
      }
    },

    /* ---- Header Cart Count ---- */
    updateHeaderCartCount: function () {
      var countEl = document.getElementById('cfHeaderCartCount');
      if (!countEl) return;
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cart.item_count > 0) {
            countEl.textContent = cart.item_count;
            countEl.removeAttribute('hidden');
          } else {
            countEl.setAttribute('hidden', '');
          }
        })
        .catch(function () {});
    },

    /* ---- Form Submit ---- */
    handleSubmit: function (e) {
      e.preventDefault();

      var hasFile = this.state.fileSelected;
      var hasIdea = this.els.ideaText && this.els.ideaText.value.trim().length > 0;
      if (!hasFile && !hasIdea) {
        this.goToStep('upload');
        this.showUploadError('Please upload a photo or describe your idea.');
        return;
      }

      if (!this.state.currentVariant) {
        return;
      }

      // Strip empty optional fields so they don't appear on orders
      var textareas = this.els.form.querySelectorAll('.cf-textarea');
      for (var i = 0; i < textareas.length; i++) {
        if (textareas[i] !== this.els.ideaText && !textareas[i].value.trim()) {
          textareas[i].removeAttribute('name');
        }
      }

      if (this.els.ideaText && !this.els.ideaText.value.trim()) {
        this.els.ideaText.removeAttribute('name');
      }

      this.showPopup();
    },

    /* ---- Artist Confirmation Popup ---- */
    showPopup: function () {
      var overlay = document.getElementById('cfPopupOverlay');
      if (!overlay) {
        this.addToCart();
        return;
      }

      var self = this;

      // Start adding to cart immediately in the background
      this.els.addToCartBtn.disabled = true;
      this.els.addToCartBtn.textContent = 'Adding\u2026';
      this._cartAdded = false;
      this._cartError = false;
      this.addToCart(function () {
        self._cartAdded = true;
      });

      // Show popup right away
      overlay.removeAttribute('hidden');
      overlay.style.display = 'flex';

      // Get CTA button (might have been cloned before, so query fresh)
      var ctaBtn = overlay.querySelector('.cf-popup__cta');
      if (!ctaBtn) return;

      // Reset button state
      ctaBtn.disabled = false;
      ctaBtn.textContent = ctaBtn.dataset.originalText || 'Continue to Cart';
      if (!ctaBtn.dataset.originalText) {
        ctaBtn.dataset.originalText = ctaBtn.textContent;
      }

      // Replace to clear old handlers
      var freshCta = ctaBtn.cloneNode(true);
      ctaBtn.parentNode.replaceChild(freshCta, ctaBtn);

      var closeHandler = function (e) {
        if (e.target === overlay) {
          overlay.style.display = 'none';
          overlay.removeEventListener('click', closeHandler);
        }
      };
      overlay.addEventListener('click', closeHandler);

      // "Continue to Cart" opens cart drawer — item is already being added
      freshCta.addEventListener('click', function () {
        overlay.removeEventListener('click', closeHandler);
        var openDrawer = function () {
          overlay.style.display = 'none';
          // Reset footer button so it isn't stuck on "Adding…" if the user closes the drawer
          self.updateCartButton();
          // Open drawer
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.openMenuDrawer === 'function') {
            drawer.openMenuDrawer();
          }
          // Refresh mini-cart contents
          var miniCart = document.getElementById('mini-cart');
          if (miniCart && miniCart.dataset.url) {
            fetch(miniCart.dataset.url)
              .then(function (r) { return r.text(); })
              .then(function (html) {
                var section = new DOMParser()
                  .parseFromString(html, 'text/html')
                  .querySelector('.shopify-section');
                if (section) miniCart.innerHTML = section.innerHTML;
              });
          }
          // Update cart icon count
          fetch('/?sections=cart-icon-bubble')
            .then(function (r) { return r.json(); })
            .then(function (sections) {
              if (sections['cart-icon-bubble']) {
                var bubble = document.getElementById('cart-icon-bubble');
                if (bubble) {
                  var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
                  var newBubble = doc.getElementById('cart-icon-bubble');
                  if (newBubble) bubble.innerHTML = newBubble.innerHTML;
                }
              }
            });
        };
        if (self._cartError) {
          // AJAX failed — fallback to native form submit
          overlay.style.display = 'none';
          var form = document.getElementById('CustomFlowForm');
          if (form) {
            var returnInput = form.querySelector('[name="return_to"]');
            if (returnInput) returnInput.value = '/cart';
            HTMLFormElement.prototype.submit.call(form);
          }
        } else if (self._cartAdded) {
          openDrawer();
        } else {
          freshCta.disabled = true;
          freshCta.textContent = 'Adding\u2026';
          var check = setInterval(function () {
            if (self._cartError) {
              clearInterval(check);
              overlay.style.display = 'none';
              var form = document.getElementById('CustomFlowForm');
              if (form) {
                var returnInput = form.querySelector('[name="return_to"]');
                if (returnInput) returnInput.value = '/cart';
                HTMLFormElement.prototype.submit.call(form);
              }
            } else if (self._cartAdded) {
              clearInterval(check);
              openDrawer();
            }
          }, 200);
        }
      }, { once: true });
    },

    /* ---- Auto-open cart drawer on return ---- */
    checkAutoOpenCart: function () {
      var params = new URLSearchParams(window.location.search);
      if (!params.has('open_cart')) return;

      // Clean URL
      var cleanUrl = window.location.pathname;
      window.history.replaceState({}, '', cleanUrl);

      // Wait for mini-cart to initialize, then open drawer
      setTimeout(function () {
        var miniCart = document.querySelector('mini-cart');
        if (miniCart) {
          // Fetch fresh cart content and open
          if (miniCart.dataset.url) {
            fetch(miniCart.dataset.url)
              .then(function (r) { return r.text(); })
              .then(function (html) {
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, 'text/html');
                var section = doc.querySelector('.shopify-section');
                if (section) {
                  document.getElementById('mini-cart').innerHTML = section.innerHTML;
                }
                var drawer = document.querySelector('cart-drawer');
                if (drawer && typeof drawer.openMenuDrawer === 'function') {
                  drawer.openMenuDrawer();
                }
              });
          }
        } else {
          // No drawer — redirect to cart
          window.location.href = '/cart';
        }
      }, 500);
    },

    /* ---- Compress image before upload ---- */
    compressImage: function (file, maxWidth, quality) {
      return new Promise(function (resolve) {
        if (!file || !file.type.startsWith('image/')) { resolve(file); return; }
        var img = new Image();
        img.onload = function () {
          var canvas = document.createElement('canvas');
          var scale = Math.min(1, maxWidth / Math.max(img.width, img.height));
          canvas.width = img.width * scale;
          canvas.height = img.height * scale;
          canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
          canvas.toBlob(function (blob) {
            resolve(new File([blob], file.name, { type: 'image/jpeg' }));
          }, 'image/jpeg', quality);
        };
        img.onerror = function () { resolve(file); };
        img.src = URL.createObjectURL(file);
      });
    },

    /* ---- Cart Add (AJAX, calls onDone when complete) ---- */
    addToCart: function (onDone) {
      var self = this;
      var form = document.getElementById('CustomFlowForm');
      if (!form) { window.location.href = '/cart'; return; }

      var formData = new FormData(form);

      // Compress each uploaded image to max 1600px, 80% quality
      var files = this.state.files || [];
      var compressPromise = files.length
        ? Promise.all(files.map(function (file, i) {
            return self.compressImage(file, 1600, 0.8).then(function (compressed) {
              formData.set(self.photoPropName(i), compressed, compressed.name);
            });
          }))
        : Promise.resolve();

      compressPromise.then(function () {
        return fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart add failed: ' + res.status);
          return res.json();
        })
        .then(function () {
          self.updateHeaderCartCount();
          if (typeof onDone === 'function') onDone();
        })
        .catch(function (err) {
          console.error('[CustomFlow] Cart error:', err);
          self._cartError = true;
          if (typeof onDone === 'function') onDone();
        });
      });
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      CustomFlow.init();
    });
  } else {
    CustomFlow.init();
  }
})();
